import Dashboard from 'Pages/Dashboard';

import SecureDownload from 'Pages/SecureDownload';

import Profile from 'Pages/Profile';
import Travel from "Pages/Cms/Elements/Travel";

export default [
    { path: '/profile', component: Profile, guards: ['auth'] },
    { path: '/', component: Dashboard, guards: ['auth'] },
    { path: '/secure-download/:id', component: SecureDownload },
    { path: '/travel', component: Travel , guards: ['auth'] },
];
